import { FaLink } from 'react-icons/fa'

import useSocialBlocks from 'src/hooks/useSocialBlocks'

import { OnClickLink } from './OnClickLink'

type CopyLinkProps = {
  text?: string
}

export const CopyLink = ({ text = 'Copy link' }: CopyLinkProps) => {
  const { handleCopyToClipboard } = useSocialBlocks()

  return (
    <OnClickLink
      className='text-shark text-[16px] leading-[20px] font-semibold'
      onClick={() => handleCopyToClipboard()}
    >
      <FaLink className='align-text-bottom inline w-[16px] h-[20px] group-hover:text-alizarin' />{' '}
      {text}
    </OnClickLink>
  )
}
